import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocationType } from '../location/location-type';
import { LocationTypeService } from '../location/location-type.service';

import { Message, ConfirmationService } from 'primeng/primeng';

@Component({
  selector: 'pl-location-type',
  templateUrl: './location-type.component.html',
  styleUrls: ['./location-type.component.css'],
  providers: [ConfirmationService]
})
export class LocationTypeComponent implements OnInit {

  locationTypeList: LocationType[];
  msgs: Message[];
  selectedLocationType: LocationType;
  testBool : boolean;

  constructor(private locationTypeService: LocationTypeService, private router: Router,
    private confirmationService: ConfirmationService) {
    this.locationTypeList = [];
    this.msgs = [];
    this.selectedLocationType = this.createDefaultLocationType();
  }

  ngOnInit() {
    this.loadLocationTypes();
  }

  private loadLocationTypes() {
    this.locationTypeService.list().subscribe(
      (locationTypeArray: LocationType[]) => {
        this.locationTypeList = [];
        for (var locationType of locationTypeArray)
          this.locationTypeList = [...this.locationTypeList, locationType];
      },
      (err) => {
        console.log(err);
        this.msgs = [];
        this.msgs.push({ severity: 'warn', summary: 'Error', detail: 'Could not load list of locationTypes.' });
      }
    );
  }

  private createDefaultLocationType() : LocationType {
    let locationType = new LocationType();
    locationType.id = -1;
    locationType.compact = false;
    locationType.count = true;
    locationType.inbound = false;
    locationType.name = "";
    locationType.outbound = false;
    locationType.picking = true;
    locationType.transport = false;
    locationType.created = new Date();
    locationType.updated = new Date();
    return locationType;
  }

  public addNew() {
    console.log('Create new LocationType.');

    /**
     * We need to check first, if there is already a new instance
     * in list of areas.
     */
    for (var a of this.locationTypeList) {
      if (a.id < 0) {
        this.selectedLocationType = a;
        this.msgs.push({ severity: 'info', summary: 'Erst neuen Platz speichern.' });
        return;
      }
    }

    let locationType = this.createDefaultLocationType();

    this.locationTypeList = [...this.locationTypeList, locationType];
    this.selectedLocationType = locationType;
  }

  /**
   * Navigate to details component
   */
  public editSelected() {
  }

  public deleteSelected() {
    console.log("Delete location type triggered");
    this.msgs = [];
    if (this.selectedLocationType == null) {
      console.log("No location type selected -> return");
      this.msgs.push({ severity: 'info', summary: 'Kein Platztyp ausgewaehlt.' });
      return;
    }
    this.confirmationService.confirm({
      message: 'Moechten Sie den Platztyp wirlich loeschen?',
      accept: () => {
        this.locationTypeService.delete(this.selectedLocationType.id).subscribe(
          (success: any) => {
            if (success != null && success.success) {
              this.msgs.push({ severity: 'info', summary: 'Platztyp wurde geloescht.' });
              this.loadLocationTypes();
            } else {
              this.msgs.push({ severity: 'warn', summary: 'Platztyp konnte nicht geloescht werden.' });
              console.log('Error on serverside.');
            }
          },
          (err) => {
            this.msgs.push({ severity: 'warn', summary: 'Platztyp konnte nicht geloescht werden.' });
            console.log(err);
          }
        );
      }
    });

  }

  /**
   * Saves or updates edited locationType entity to server.
   */
  public onSave() {
    if (this.selectedLocationType == null || this.selectedLocationType.id == null)
      this.msgs.push({ severity: 'info', summary: 'Please add or selected an locationType first.' });

    if (this.selectedLocationType.id == -1) {
      this.locationTypeService.save(this.selectedLocationType).subscribe(
        (res) => {
          let msg: Message = { severity: 'info', detail: 'Der Platztyp wurde gespeichert.', summary: 'Gespeichert!' };
          this.msgs = [];
          this.msgs.push(msg);
          this.loadLocationTypes();
        },
        (err) => {
          let msg: Message = { severity: 'warn', detail: 'Der Platztyp konnte nicht gespeichert werden.', summary: 'Fehler!' };
          this.msgs = [];
          this.msgs.push(msg);
          console.log('Could not save locationType, error msg: ' + err);
        }
      );
    }
    else {
      this.locationTypeService.update(this.selectedLocationType).subscribe(
        (res) => {
          let msg: Message = { severity: 'info', detail: 'Der Platztyp wurde gespeichert.', summary: 'Gespeichert!' };
          this.msgs = [];
          this.msgs.push(msg);
          this.loadLocationTypes();
        },
        (err) => {
          let msg: Message = { severity: 'warn', detail: 'Der Platztyp konnte nicht gespeichert werden.', summary: 'Fehler!' };
          this.msgs = [];
          this.msgs.push(msg);
          console.log('Could not save locationType, error msg: ' + err);
        }
      );
    }
  }
}


// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/location-type/location-type.component.ts